/* FM Geo M2 gallery — expand + simple lightbox. No dependency. */
(function () {
  function initGallery(root) {
    if (!root || root.dataset.fmGeoInit === '1') return;
    root.dataset.fmGeoInit = '1';

    var toggle = root.querySelector('[data-fm-gallery-toggle]');
    var track = root.querySelector('[data-fm-gallery-track]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open
          ? toggle.getAttribute('data-label-less') || 'Show less'
          : toggle.getAttribute('data-label-more') || 'Show all';
      });
    }

    var slides = root.querySelectorAll('[data-fm-gallery-src]');
    if (!slides.length) return;

    var lb = root.querySelector('[data-fm-lb]');
    if (!lb) return;
    var img = lb.querySelector('[data-fm-lb-img]');
    var btnClose = lb.querySelector('[data-fm-lb-close]');
    var btnPrev = lb.querySelector('[data-fm-lb-prev]');
    var btnNext = lb.querySelector('[data-fm-lb-next]');
    var index = 0;
    var sources = Array.prototype.map.call(slides, function (el) {
      return el.getAttribute('data-fm-gallery-src');
    });

    function show(i) {
      index = (i + sources.length) % sources.length;
      img.src = sources[index];
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function hide() {
      lb.hidden = true;
      img.removeAttribute('src');
      document.documentElement.style.overflow = '';
    }

    slides.forEach(function (el, i) {
      el.addEventListener('click', function () {
        show(i);
      });
    });
    if (btnClose) btnClose.addEventListener('click', hide);
    if (btnPrev) btnPrev.addEventListener('click', function () { show(index - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { show(index + 1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb) hide();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') hide();
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  }

  function boot() {
    document.querySelectorAll('[data-fm-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
